/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

//import "common/samples-common.scss";
import { HitDetail, imageElementFromUrl, ToolAdmin} from "@itwin/core-frontend";
import { cQuery } from "./Query";
import { cImageApi } from "./Image";

/** To create the tooltip, a class needs to override ToolAdmin and getToolTip() */
export class cTooltip extends ToolAdmin {
  private static _singleton: cTooltip;

  public static initialize = (): cTooltip => {
    if (!cTooltip._singleton) cTooltip._singleton = new cTooltip();
    return cTooltip._singleton;
  }

  public static get = (): cTooltip => {
    return cTooltip._singleton;
  }

  private constructor() {
    super();
  }

  public getToolTip = async (hit: HitDetail): Promise<HTMLElement | string> => {
    if (null === cTooltip._singleton) return "";

    let needDefault = true;
    let tagText: string;
    const tip = document.createElement("div");

    if (hit.isElementHit) {
      const tag = await cQuery.getElementTag([hit.sourceId]);
      if (tag[0] !== "") {
        if (tag[0].toLowerCase().includes(".jpg")) {
          //          const imgHTML = await imageElementFromUrl(`./image/${tag}`);
          const image = await cImageApi.fetchImage(tag[0]);
          const imgHTML = document.createElement("img") as HTMLImageElement;
          imgHTML.src = image;
          imgHTML.height = 182;
          imgHTML.width = 270;
          tip.appendChild(imgHTML);
        } else {
          tagText = `${tag}`;
          const data = await cQuery.getItemTypeById("Classifier.Label", hit.sourceId);
          if (data && data.length > 0) {
            // if (data[0].type) tagText += `<br>${data[0].type}`;
            // if (data[0].skid) tagText += `<br>Skid: ${data[0].skid}`;
            if (data[0][1]) tagText += `<br>${data[0][1]}`;
            if (data[0][2]) tagText += `<br>Skid: ${data[0][2]}`;
          }
          const tagHTML = document.createElement("span");
          tagHTML.innerHTML = tagText; //!!OA
          tip.appendChild(tagHTML);
        }
        needDefault = false;
      }
    }

    // default tooltip
   // needDefault = true;
    if (needDefault) {
      throw ""; //!!OA - doesn't show tooltip - is this correct!!!
      // let defaultTip = await super.getToolTip(hit);
      // if (typeof defaultTip === "string") {
      const htmlTip = document.createElement("span");
      htmlTip.innerHTML = "Reality Model";
      tip.appendChild(htmlTip);
    }

    return tip;
  }
}
